import React from 'react';

export default function ComparisonPatentCard({ patent, onRemove, isYourPatent, onMarkAsYours }) {
    const formatDate = (dateString) => {
        if (!dateString) return 'N/A';
        const date = new Date(dateString);
        return date.toLocaleDateString('en-US', { year: 'numeric', month: 'short', day: 'numeric' });
    };

    const getFirstAssignee = () => {
        if (patent.assignee) return patent.assignee;
        if (patent.assignees && patent.assignees.length > 0) {
            return Array.isArray(patent.assignees) ? patent.assignees[0] : patent.assignees;
        }
        return 'Unassigned';
    };

    return (
        <div className={`comparison-patent-card ${isYourPatent ? 'your-patent' : ''}`}>
            <div className="card-header">
                <div 
                    className="patent-number-badge clickable-patent-number"
                    onClick={() => {
                        const patentNumber = patent.patent_number || patent.id;
                        window.open(`https://worldwide.espacenet.com/patent/search?q=${patentNumber}`, '_blank');
                    }}
                    title="Click to view full patent on Espacenet (opens in new tab)"
                    style={{ cursor: 'pointer' }}
                >
                    US{patent.patent_number || patent.id}
                </div>
                <button
                    className="remove-btn"
                    onClick={() => onRemove(patent.patent_number || patent.id)}
                    title="Remove from comparison"
                >
                    ×
                </button>
            </div>

            <h3 className="patent-title">{patent.title}</h3>

            <div className="patent-details">
                <div className="detail-row">
                    <span className="detail-label">Assignee:</span>
                    <span className="detail-value">{getFirstAssignee()}</span>
                </div>
                <div className="detail-row">
                    <span className="detail-label">Grant Date:</span>
                    <span className="detail-value">{formatDate(patent.grant_date)}</span>
                </div>
                <div className="detail-row">
                    <span className="detail-label">CPC:</span>
                    <span className="detail-value">
                        {patent.cpc_codes && patent.cpc_codes.length > 0 
                            ? `${patent.cpc_codes.slice(0, 2).join(', ')}${patent.cpc_codes.length > 2 ? ` +${patent.cpc_codes.length - 2}` : ''}`
                            : 'N/A'}
                    </span>
                </div>
            </div>

            <button
                className={`mark-yours-btn ${isYourPatent ? 'marked' : ''}`}
                onClick={() => onMarkAsYours(patent.patent_number || patent.id)}
            >
                {isYourPatent ? '★ Your Patent' : 'Mark as "Your Patent"'}
            </button>
        </div>
    );
}